export const LOAD_BANK_NAMES = 'LOAD_BANK_NAMES';
export const LOAD_UNIVERSAL_BRANCHES = 'LOAD_UNIVERSAL_BRANCHES';
export const LOAD_FUND_NAMES = 'LOAD_FUND_NAMES';
